import d, { forwardRef as C, useRef as A, useMemo as Q, useEffect as F } from "react";
import V, { l as m } from "./index312.mjs";
import "./index97.mjs";
import { useComponentDefaultProps as M, Box as $ } from "@mantine/core";
import { Toolbar as q } from "./index314.mjs";
import { DEFAULT_CONTROLS as z } from "./index315.mjs";
import G from "./index316.mjs";
import { DEFAULT_LABELS as H } from "./index317.mjs";
import { createImageBlot as J } from "./index318.mjs";
import { ImageUploader as K } from "./index319.mjs";
import { replaceIcons as W } from "./index320.mjs";
import { attachShortcuts as X } from "./index321.mjs";
import { useId as Y } from "./index174.mjs";
import { mergeRefs as Z } from "./index176.mjs";
var ee = Object.defineProperty, re = Object.defineProperties, oe = Object.getOwnPropertyDescriptors, n = Object.getOwnPropertySymbols, P = Object.prototype.hasOwnProperty, E = Object.prototype.propertyIsEnumerable, h = (e, o, r) => o in e ? ee(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, f = (e, o) => {
  for (var r in o || (o = {}))
    P.call(o, r) && h(e, r, o[r]);
  if (n)
    for (var r of n(o))
      E.call(o, r) && h(e, r, o[r]);
  return e;
}, te = (e, o) => re(e, oe(o)), ae = (e, o) => {
  var r = {};
  for (var t in e)
    P.call(e, t) && o.indexOf(t) < 0 && (r[t] = e[t]);
  if (e != null && n)
    for (var t of n(e))
      o.indexOf(t) < 0 && E.call(e, t) && (r[t] = e[t]);
  return r;
};
const le = m.Quill.import("blots/block"), se = J(le);
m.Quill.register({ "formats/imageBlot": se });
m.Quill.register("modules/imageUploader", K);
const ie = m.Quill.import("ui/icons");
W(ie);
function ne(e) {
  return new Promise((o) => {
    const r = new FileReader();
    r.onloadend = () => o(r.result), r.readAsDataURL(e);
  });
}
const me = {
  onImageUpload: ne,
  sticky: !0,
  stickyOffset: 0,
  labels: H,
  controls: z,
  readOnly: !1
}, de = C((e, o) => {
  const r = M("RichTextEditor", me, e), {
    value: t,
    defaultValue: R,
    onChange: I,
    onImageUpload: c,
    sticky: w,
    stickyOffset: U,
    radius: x,
    labels: a,
    controls: L,
    id: N,
    className: T,
    classNames: p,
    styles: u,
    placeholder: k,
    mentions: _,
    readOnly: v,
    modules: y,
    unstyled: g,
    formats: B
  } = r, D = ae(r, [
    "value",
    "defaultValue",
    "onChange",
    "onImageUpload",
    "sticky",
    "stickyOffset",
    "radius",
    "labels",
    "controls",
    "id",
    "className",
    "classNames",
    "styles",
    "placeholder",
    "mentions",
    "readOnly",
    "modules",
    "unstyled",
    "formats"
  ]), l = Y(N), s = A(), { classes: O, cx: S } = G({
    saveLabel: a.save,
    editLabel: a.edit,
    removeLabel: a.remove,
    radius: x,
    readOnly: v
  }, { classNames: p, styles: u, unstyled: g, name: "RichTextEditor" }), j = Q(() => te(f(f({}, y), l ? { toolbar: { container: `#${l}` } } : void 0), {
    mention: _,
    imageUploader: {
      upload: (i) => c(i)
    }
  }), [l, _, y, c]);
  return F(() => {
    var i, b;
    s.current && X((b = (i = s == null ? void 0 : s.current) == null ? void 0 : i.editor) == null ? void 0 : b.keyboard);
  }, []), /* @__PURE__ */ d.createElement($, f({
    className: S(O.root, T)
  }, D), /* @__PURE__ */ d.createElement(q, {
    controls: L,
    labels: a,
    sticky: w,
    stickyOffset: U,
    classNames: p,
    styles: u,
    id: l,
    className: O.toolbar,
    unstyled: g
  }), /* @__PURE__ */ d.createElement(V, {
    theme: "snow",
    modules: j,
    value: t,
    defaultValue: R,
    onChange: I,
    ref: Z(s, o),
    placeholder: k,
    readOnly: v,
    scrollingContainer: "html",
    formats: B
  }));
});
de.displayName = "@mantine/rte/RichTextEditor";
export {
  z as DEFAULT_CONTROLS,
  H as DEFAULT_LABELS,
  de as RichTextEditor
};
